import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { searchUangJalanReportsApi } from "../../api/uangJalanReportsApi";
import type { UangJalanReport, UangJalanReportSearchFilters } from "../../types/uangJalanReport";
import type { PaginationParam, PaginationResponse } from "../../types/paginationResponse";

interface UangJalanReportState {
  uangJalanReports: UangJalanReport[];
  loading: boolean;
  error: string | null;
  pagination: PaginationResponse | null;
}

const initialState: UangJalanReportState = {
  uangJalanReports: [],
  loading: false,
  error: null,
  pagination: null,
};

export const searchUangJalanReports = createAsyncThunk<
  { uangJalanReports: UangJalanReport[]; pagination: PaginationResponse },
  { filters?: UangJalanReportSearchFilters; pagination?: PaginationParam },
  { rejectValue: string }
>(
  "uangJalanReports/searchUangJalanReports",
  async ({ filters, pagination }, { rejectWithValue }) => {
    try {
      return await searchUangJalanReportsApi(filters, pagination);
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to search uang jalan reports",
      );
    }
  },
);

const uangJalanReportSlice = createSlice({
  name: "uangJalanReports",
  initialState,
  reducers: {
    clearUangJalanReportsError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchUangJalanReports.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchUangJalanReports.fulfilled, (state, action) => {
        state.loading = false;
        state.uangJalanReports = action.payload.uangJalanReports;
        state.pagination = action.payload.pagination;
      })
      .addCase(searchUangJalanReports.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to search uang jalan reports";
      });
  },
});

export const { clearUangJalanReportsError } = uangJalanReportSlice.actions;
export default uangJalanReportSlice.reducer;
